import AccountSettings from './pages/AccountSettings';
import ManagementUsers from './pages/ManagementUsers';
import {useAuth} from './hooks/useAuth';
import Commercial from './pages/Commercial';
import Sales from './pages/Sales';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from './theme';
import { Toaster } from 'react-hot-toast';
import { useStore } from './store';
import { integradoresAPI, instanciasAPI } from './api';
import { AuthProvider } from './contexts/AuthContext';
import MainLayout from './components/MainLayout';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import Integradores from './pages/Integradores';
import Instancias from './pages/Instancias';
import Faturamento from './pages/Faturamento';
import Infraestrutura from './pages/Infraestrutura';

function AppContent() {
  const {isAuthenticated}=useAuth();
  const { setIntegradores, setInstancias, setLoading, setError } = useStore();

  useEffect(() => {
    if (isAuthenticated) carregarDados();
  }, [isAuthenticated]);

  const carregarDados = async () => {
    setLoading(true);
    try {
      const [integradoresRes, instanciasRes] = await Promise.all([
        integradoresAPI.listar(),
        instanciasAPI.listar(),
      ]);

      setIntegradores(integradoresRes.data.data);
      setInstancias(instanciasRes.data.data);
      setError(null);
    } catch (error) {
      setError('Erro ao carregar dados');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <BrowserRouter>
        <CssBaseline />
        <Toaster position="top-right" />
        <Routes>
          {/* Rota pública */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<LoginPage />} />
          <Route path="/reset-password" element={<LoginPage />} />
          <Route path="/planos" element={<Sales />} />
          
          {/* Rotas protegidas */}
          <Route element={<MainLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/integradores" element={<Integradores />} />
            <Route path="/instancias" element={<Instancias />} />
            <Route path="/faturamento" element={<Faturamento />} />
            <Route path="/comercial" element={<Commercial />} />
            <Route path="/infraestrutura" element={<Infraestrutura />} />
            <Route path="/management-users" element={<ManagementUsers />} />
            <Route path="/settings" element={<AccountSettings/>} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default function App(){return <ThemeProvider theme={theme}><AuthProvider><AppContent/></AuthProvider></ThemeProvider>;}
